<template>
    <!-- TODO css -->
    <modal @close="modals.userSettings = false" :width="550">
        <div v-if="screen === 'form'">
            <h3>{{ teamMember.name }}</h3>
            <div class="large-form">
                <div class="form-line">
                    <div id="form-field-name" class="form-field" style="width: 100%">
                        <label for="form-input-name">Team Member Name</label>
                        <input v-model="editUser.name" type="text" id="form-input-name" required="required" />
                    </div>
                </div>
                <div class="form-line">
                    <div id="form-field-email" style="width: 60%"  class="form-field">
                        <label for="name">Team Member Email</label>
                        <div class="form-static-field">{{ teamMember.email }}</div>
                    </div>            
                    <div id="form-field-role" style="width: 40%" class="form-field">
                        <label for="name">Role</label>
                        <div class="form-static-field"><b>{{ fullRoleName(teamMember.role) }}</b></div>
                    </div>
                </div>
                <div class="form-line">
                    <div class="form-field form-field-checkbox form-field-checkbox-extended" style="width: 100%">
                        <label for="form-input-name">Permissions</label>
                        <div class="form-field-box">
                            <div class="checkbox-option" v-for="permission in permissionsList">
                              <input v-model="editUser.permissions" type="checkbox" name="permissions" :value="permission.slug" :disabled="!['associate'].includes(teamMember.role)">
                              <div class="checkbox-label">
                                <h5>{{ permission.name }}</h5>
                                <p>{{ permission.text }}</p>
                              </div>
                            </div>
                        </div>
                        
                        <div v-if="['manager'].includes(teamMember.role)" class="small-note"><span>NOTE:</span> <i><b>Team Managers</b></i> always have full permissions.</div>
                    </div>
                </div>
                <div class="modal-errors">
                    <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
                </div>
            </div>
            <div class="form-actions">
              <span class="ws-button ws-button-secondary" data-action="cancel" @click="modals.userSettings = false">Cancel</span>
              <span class="ws-button ws-button-main" data-action="start-campaign-confirm" @click="updateUser">Save Changes</span>
            </div>
        </div>
        <!-- Loading -->
        <div v-else-if="screen === 'loading'">
            <div class="ws-form-processing"><div class="value-loader"></div><p>We're retrieving team member details.<br>Please give us a moment...</p></div>
        </div>
        
        <!-- Loading -->
        <div v-else-if="screen === 'processing'">
            <div class="ws-form-processing"><div class="value-loader"></div><p>We're saving your changes.<br>Please give us a moment...</p></div>
        </div>
        
    </modal>
</template>

<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "UserSettingsModal",
    components: {Modal},
    props: ['teamMemberId'],
    data() {
        return {
            editUser: {name:'', permissions: []},
            errors: {},
            screen: 'loading',
        }
    },
    methods: {
        async updateUser() {
            if (!this.demoCheck()) return;
            
            this.errors = this.validateFields([
                { name: 'Name', value: this.editUser.name, rules: ['required', 'minLength:1'] },
            ]);
            if (Object.keys(this.errors).length) return;
            this.screen = 'processing';
            await this.dispatchWaitAndNotify('updateTeamMember', {userId: this.teamMemberId, data: this.editUser});
            this.$emit('updated');
        },
        fullRoleName(name) {
            if (name=='manager') return 'Team Manager';
            else if (name=='associate') return 'Team Associate';
            else if (name=='bb_admin') return 'BB HUB Account Manager';
            else return name;
        },
    },
    async mounted() {
        await this.dispatchWaitAndNotify('fetchTeamMember', this.teamMemberId, false, true); 
        this.editUser.name = this.teamMember.name;
        this.editUser.permissions = this.teamMember.permissions;
        this.screen = 'form';
    },
    computed: {
        team() {
            return this.$store.state.team.detail;
        },
        teamMember() {
            return this.$store.state.team.teamMember;
        },
        modals() {
            return this.$store.state.modals;
        },
        permissionsList() {
            return this.$store.state.permissionsList;
        },
    }
}
</script>

<style scoped>

</style>